export default __webpack_public_path__ + "static/media/jpnews.a7c4c959.png";